import React from 'react';
import styled, { css } from 'styled-components';

import { Typography } from 'src/typography';
import { GoodCannaIcon } from '../good-canna-icon';

export const GoodCannaFooter = (): JSX.Element => (
  <Footer>
    <PoweredBy>
      <GoodCannaIcon width={24} height={24} />
      <div>
        <Typography.Body tag='p' size='xxsmall'>
          Powered by
        </Typography.Body>
        <Typography.Body tag='h4' size='medium'>
          GoodCannaNow
        </Typography.Body>
      </div>
    </PoweredBy>
  </Footer>
);

const Footer = styled.div`
  ${({ theme: { colors } }) => css`
    color: ${colors.grey[45]};

    a {
      text-decoration: underline;
    }
  `}
`;

const PoweredBy = styled.div`
  ${({ theme: { colors, spaces } }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${spaces[2]};
    margin-bottom: ${spaces[2]};
    text-align: left;

    p {
      font-size: 10px;
      line-height: 1;
      margin-bottom: 0;
    }

    h4 {
      color: ${colors.black};
      line-height: 1.1;
      font-weight: 700;
    }
  `}
`;
